import JsTabs from "js-tabs";
import config from "./Config/config";

require("./base");

import Order from "./Components/basket/order";

require("./Components/suggestions");

import { calculator } from "./Components/basket/Calculator/DefaultCalculator";
import { getCartData } from "./Components/basket/get-cart-data";
import updateItem from "./Components/basket/updateItem";
import { deleteFromBasket } from "./Components/basket/deleteFromBasket";

import events from "./base";
import { changeInputFile } from "./Components/input-file";
import { parseHTML } from "./Components/Core/common";
import Agent from "./Components/Core/agent";

new Order(events);

const state = {
  index: "",
  deliveryIndex: "",
  isUpdatedDelivery: true,
  coupon: "",
  deliveryPrice: 0,
  packingPrice: 0,
  PaymentVariant: "",
  carData: undefined,
  promo: "",
};

const updaterCartInfo = () => {
  if (!state.carData) {
    getCartData(state.coupon, state.PaymentVariant).then((e) => {
      state.carData = e;
      events.dispatch(
        config.listeners.basket.added,
        state.carData,
        state.deliveryPrice,
        state.packingPrice,
        state.PaymentVariant,
      );
    });
  } else {
    events.dispatch(
      config.listeners.basket.added,
      state.carData,
      state.deliveryPrice,
      state.packingPrice,
      state.PaymentVariant,
    );
  }
};

const setCartData = (cartData) => {
  state.carData = cartData;
  updaterCartInfo();
};

const setCartDataWitchClearDeliveryAndPackingPrice = (cartData) => {
  setCartData(cartData);
};

let calc = calculator(events);
calc.init("section.basket .js_item");

events.addListener("item.deleted", null, calc.delete.bind(calc));
events.addListener("item.deleted", null, (e, j) =>
  setCartDataWitchClearDeliveryAndPackingPrice(j),
);

events.addListener("paper.update", null, (element, data) =>
  updateItem(element, data, state.coupon, state.PaymentVariant, events),
);

events.addListener("item.updated", null, (e) =>
  setCartDataWitchClearDeliveryAndPackingPrice(e),
);

document.querySelectorAll(".js_del_good_cart").forEach((item) =>
  item.addEventListener("click", (event) => {
    deleteFromBasket(event, state.coupon, state.PaymentVariant, events);
  }),
);

document.querySelectorAll(".js_delivery_tab").forEach((item) => {
  item.addEventListener("click", () => {
    document.querySelector('[name="delivery_variant"]').value = item.dataset.id;
  });
});

document.querySelectorAll(".js_set_payment").forEach((item) => {
  item.addEventListener("click", () => {
    document.querySelector('[name="payment_variant"]').value = item.dataset.id;
  });
});

// const setPaymentVariant = () => {
//     let currentPaymentVariant = state.PaymentVariant;
//     let organization = document.querySelector('[name="organization"]');
//
//     document.querySelector('[name="payment_variant"]').value = organization.value.trim().length ?
//         document.querySelector('[name="payment_transfer"]').value :
//         document.querySelector('[name="payment_agreement"]').value;
//
//     state.PaymentVariant = document.querySelector('[name="payment_variant"]').value;
//
//     if (currentPaymentVariant !== state.PaymentVariant) {
//         state.carData = undefined;
//         updaterCartInfo();
//     }
// };

// let organizationTimer;
// document.querySelectorAll('[name="organization"]').forEach(item => {
//     item.addEventListener('input', () => {
//         clearTimeout(organizationTimer);
//         organizationTimer = setTimeout(setPaymentVariant, 1000);
//     });
// });

updaterCartInfo();

function tabs(tabName) {
  if (document.querySelector(tabName)) {
    document.querySelectorAll(tabName).forEach((item) => {
      let tab = new JsTabs({
        elm: item,
        shouldScrollTabIntoView: false,
      });
      tab.init();
      item.querySelector(".js-tabs__tab").classList.add("active");
      item.querySelector(".js-tabs__content").classList.add("active");
    });
  }
}

tabs(".cart-tabs");

document.querySelectorAll('[type="file"]').forEach((el) => {
  if (el.getAttribute("type") === "file") {
    el.addEventListener("change", () => changeInputFile(el));
  }
});

let d = new Date();
let loc = Date.UTC(
  d.getFullYear(),
  d.getMonth(),
  d.getDate(),
  d.getHours(),
  d.getMinutes(),
  d.getSeconds(),
);
const inputTimeZone = document.createElement("input");
inputTimeZone.type = "hidden";
inputTimeZone.value = (
  (document.body.dataset.time - loc / 1000) /
  3600
).toFixed(0);
inputTimeZone.name = "user_data_time_zone";
document.body.append(inputTimeZone);

document.querySelectorAll('input[name="payment_variant"]').forEach((input) => {
  if (document.querySelector(".js_form_file")) {
    let btn = document.querySelector(".js_form_file");
    input.addEventListener("change", function () {
      if (input.classList.contains("js_payment_on_account")) {
        btn.classList.add("active");
        btn.style.height = "auto";
        let height = "40px";
        btn.style.height = "0px";
        setTimeout(function () {
          btn.style.height = height;
        }, 0);
      } else {
        btn.style.height = "0px";
        setTimeout(function () {
          btn.classList.remove("active");
        }, 350);
      }
    });
  }
});

document
  .querySelectorAll(".js_benefit")
  .forEach((item) =>
    item
      .querySelector(".btn-close")
      .addEventListener("click", () => (item.style.display = "none")),
  );

let giftsContainer = document.querySelector(".js_gifts_block");
let giftsBlock = giftsContainer.querySelector(".row");
let addPromo = document.querySelector(".js_add_promo");

const clearGifts = () => {
  giftsBlock.innerHTML = "";
  giftsContainer.classList.add("d-none");
};
const renderGifts = (gifts) => {
  gifts.forEach((item) => {
    giftsBlock.append(
      parseHTML(`<div class="col-xl-4 col-sm-6">
                                    <a class="cart-gift d-flex border border-2 border-grey" href="#">
                                        <div class="cart-gift__img">
                                            <img class="lazy h-100" src="${item.image}" alt="${item.title}">
                                        </div>
                                        <div class="cart-gift__desc d-flex flex-column justify-content-between gap-10 p-15">
                                            <div class="fs-14 fw-rg">${item.title}</div>
                                            <div class="fs-12 lh-1_4 o-0_7">${item.count} шт</div>
                                        </div>
                                    </a>
                                </div>`),
    );
  });
  giftsContainer.classList.remove("d-none");
};
const getGifts = () => {
  clearGifts();

  Agent.post(
    "/api/v1/gift",
    JSON.stringify({
      code: state.promo,
    }),
    {
      headers: {
        "Content-Type": "application/json;",
      },
    },
  )
    .then((e) => e.json())
    .then((e) => {
      if (e.success && e.data.length) {
        renderGifts(e.data);
      }
      document.querySelector(".js_remove_promo_message").innerHTML = e.message;
    })
    .finally(() => {
      addPromo.classList.remove("preloader");
    });
};
events.addListener(config.listeners.basket.deleted, null, getGifts);

events.addListener("item.updated", null, getGifts);

addPromo.addEventListener("click", () => {
  addPromo.classList.add("preloader");
  state.promo = document.querySelector('[name="promo"]').value.trim();
  if (state.promo.length) {
    document.querySelector(".js_remove_promo_block").classList.remove("d-none");
    getGifts();
  } else {
    clearGifts();
    document.querySelector(".js_remove_promo_block").classList.add("d-none");
  }
});

document.querySelector(".js_clear_promo_code").addEventListener("click", () => {
  document.querySelector(".js_remove_promo_block").classList.add("d-none");
  document.querySelector('[name="promo"]').value = "";
  state.promo = "";
  clearGifts();
});
